import { jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback } from 'react';
import { MenuContext } from './context.es.js';

/**
 * Menu Provider.
 */ const MenuProvider = ({ role = 'menu', children, open: initialOpen, ...rest })=>{
    const [open, setOpen] = useState(initialOpen);
    const values = useMemo(()=>{
        return {
            role,
            open,
            ...rest
        };
    }, [
        open,
        rest,
        role
    ]);
    const handleSetOpen = useCallback((open)=>{
        setOpen(open);
    }, []);
    const actions = useMemo(()=>({
            setOpen: handleSetOpen
        }), [
        handleSetOpen
    ]);
    return jsx(MenuContext.Provider, {
        value: [
            values,
            actions
        ],
        children: children
    });
};
MenuProvider.displayName = 'MenuV2.Provider';

export { MenuProvider };
//# sourceMappingURL=provider.es.js.map
